import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useProductConfigurationStore = defineStore('productConfiguration', () => {
    const all = ref(null);

    const form = ref({
        data_sources: [],
        attribute_catalog: [],
        data_fields: [],
    });

    const detail = ref(null);

    const reset = () => {
        all.value = null;
        form.value = {
            data_sources: [],
            attribute_catalog: [],
            data_fields: [],
        };
        detail.value = null;
    };

    const search = (params) => axios.get('/api/v1/product-configurations', { params });

    const store = (payload) => axios.post('/api/v1/product-configurations', payload);

    const update = (hash, payload) => axios.patch(`/api/v1/product-configurations/${hash}`, payload);

    const fetchDetail = async (hash) => {
        const res = await axios.get(`/api/v1/product-configurations/${hash}/detail`);

        detail.value = res?.data?.product ?? null;

        return res;
    };

    return {
        all,
        form,
        detail,
        reset,
        search,
        store,
        update,
        fetchDetail,
    };
});
